var _path, _path2, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRefToOrderlyPortFolio = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 57,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.875 0h-3.579l3.58 3.58V0Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M5.624 1.022h4.602v4.25L7.69 7.628 5.624 5.563v-4.54ZM7.65 9.758l2.576-2.393v9.51H5.624V7.731L7.65 9.758Zm3.086.974a4.858 4.858 0 0 0 4.177-7.72l-4.177 3.879v3.841Zm0-5.935 3.085-2.865a4.836 4.836 0 0 0-3.085-.902v3.767ZM5.114 1.023H0v6.585l3.835-3.835 1.279 1.28v-4.03Zm0 6.199-1.28-1.28L0 9.778v7.098h5.114V7.222Zm11.761 9.653H10.74v-6.137l6.136 6.137ZM56.455 11.52a9.004 9.004 0 0 1-17.285 0h5.588a3.952 3.952 0 0 0 3.055 1.44c1.23 0 2.328-.56 3.054-1.44h5.588Zm.178-.72H51.34c.276-.54.432-1.152.432-1.8 0-.648-.156-1.26-.432-1.8h5.291a9.044 9.044 0 0 1 0 3.6Zm-12.348 0a3.944 3.944 0 0 1-.432-1.8c0-.648.155-1.26.431-1.8h-5.291a9.044 9.044 0 0 0 0 3.6h5.292Zm-3.673-7.2a8.97 8.97 0 0 0-1.442 2.88h5.588a3.952 3.952 0 0 1 3.055-1.44c1.23 0 2.329.56 3.055 1.44h5.587a8.97 8.97 0 0 0-1.442-2.88H40.612Zm13.8-.72H41.213A8.976 8.976 0 0 1 47.813 0a8.976 8.976 0 0 1 6.598 2.88Z",
  clipRule: "evenodd"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 23.344,
  cy: 9.844,
  r: 0.844,
  fill: "#fff"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 27.844,
  cy: 9.844,
  r: 0.844,
  fill: "#fff"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.344,
  cy: 9.844,
  r: 0.844,
  fill: "#fff"
})));
export default SvgRefToOrderlyPortFolio;